import { profileData } from '../lib/profile';

// mini longitudinal profile: ground (brown) + pipe invert (blue)
export default function ProfileChart({ t, profile, press }) {
  const d = profileData(profile);
  if (!d) return null;
  const W = 300, Hh = 120, P = 28;
  const x = (st) => P + (st / (d.len || 1)) * (W - P - 6);
  const y = (h) => 6 + (1 - (h - d.min) / (d.max - d.min)) * (Hh - P);
  const pr = press ? d.pts.map((p) => [p.st, p.pipe ?? p.ground]).filter(([, h]) => h != null).map(([s, h]) => [s, press.at(h)]) : [];
  const bMin = pr.length ? Math.min(...pr.map((v) => v[1])) : 0, bMax = pr.length ? Math.max(...pr.map((v) => v[1])) : 1;
  const yb = (b) => 6 + (1 - (b - bMin) / (bMax - bMin || 1)) * (Hh - P);
  const line = (k) => d.pts.filter((p) => p[k] != null).map((p) => `${x(p.st).toFixed(1)},${y(p[k]).toFixed(1)}`).join(' ');
  return (
    <figure className="profile-chart" data-testid="profile-chart">
      <figcaption>{t.glProfile} · {d.len.toFixed(1)} m</figcaption>
      <svg viewBox={`0 0 ${W} ${Hh}`} role="img" aria-label={t.glProfile}>
        <line x1={P} y1={Hh - P + 6} x2={W - 6} y2={Hh - P + 6} stroke="#94a3b8" />
        <line x1={P} y1={6} x2={P} y2={Hh - P + 6} stroke="#94a3b8" />
        <text x={2} y={12} fontSize="9" fill="#475569">{d.max.toFixed(1)}</text>
        <text x={2} y={Hh - P + 6} fontSize="9" fill="#475569">{d.min.toFixed(1)}</text>
        <text x={W - 6} y={Hh - 6} fontSize="9" fill="#475569" textAnchor="end">{d.len.toFixed(1)} m</text>
        <polyline points={line('ground')} fill="none" stroke="#92400e" strokeWidth="2.2" data-testid="profile-ground-line" />
        <polyline points={line('pipe')} fill="none" stroke="#1565c0" strokeWidth="2.2" strokeDasharray="5 3" data-testid="profile-pipe-line" />
        {pr.length > 1 && <polyline points={pr.map(([s, b]) => `${x(s).toFixed(1)},${yb(b).toFixed(1)}`).join(' ')} fill="none" stroke="#0d9488" strokeWidth="2" data-testid="profile-pressure-line" />}
        {pr.length > 1 && <text x={W - 6} y={12} fontSize="9" fill="#0d9488" textAnchor="end" data-testid="profile-pressure-range">{bMax.toFixed(1)} … {bMin.toFixed(1)} bar</text>}
        {d.pts.map((p, i) => p.ground != null && <circle key={i} cx={x(p.st)} cy={y(p.ground)} r="2.4" fill="#92400e" />)}
      </svg>
      <div className="profile-legend"><span><i style={{ background: '#92400e' }} />{t.gnssGround}</span><span><i style={{ background: '#1565c0' }} />{t.gnssPipe}</span>{pr.length > 1 && <span><i style={{ background: '#0d9488' }} />{t.prCurve}</span>}</div>
    </figure>
  );
}
